module.exports = __webpack_public_path__ + "static/media/Baking Powder.a285aa5f.jpg";